import { useEffect } from 'react';

const useBeforeUnload = (polling: boolean) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (polling) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    if (polling) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [polling]);
};

export default useBeforeUnload;
